import React from "react";
// import { TableDatabase } from "../../components";
import { RiUserSearchFill } from "react-icons/ri";
// import { Spinner } from "react-rainbow-components";
import ModalPets from "../../components/common/ModalPets";
import useDatabaseUserPage from "./useDatabaseUserPage";
// import convertDataToRows from "./conversDataToTableRows";
import {
  Container,
  ContainerSearce,
  ContainerTable,
  HeaderContainer,
  HeaderTitle,
  SearchInput,
  CustomTable,
} from "./index.style";
import { columns } from "./conversDataToTableRows";
import { ColumnsType } from "antd/lib/table";

export default function DatabaseCustomerPage() {
  const {
    setSearchKey,
    isLoading,
    dataForShow,
    isShowModel,
    dataModal,
    setIsShowModel,
    handleShowModalPets,
  } = useDatabaseUserPage();

  return (
    <Container>
      <ModalPets
        isOpen={isShowModel}
        setIsOpen={setIsShowModel}
        data={dataModal}
      />
      <HeaderContainer>
        <HeaderTitle>
          <RiUserSearchFill size="2rem" />
          <h1>ฐานข้อมูลลูกค้า</h1>
        </HeaderTitle>
        <ContainerSearce>
          <p>ค้นหา</p>
          <SearchInput
            placeholder="ชื่อ / ชื่อไลน์ / เบอร์โทร / สัตว์เลี้ยง"
            onChange={(event) => setSearchKey(event.target.value)}
          />
        </ContainerSearce>
      </HeaderContainer>
      <ContainerTable>
        {/* {isLoading ? (
          <Spinner size="large" variant="brand" />
        ) : (
          <TableDatabase
            header={["ชื่อลูกค้า", "ไลน์", "เบอร์โทร", "อีเมล", "สัตว์เลี้ยง"]}
            tableRows={convertDataToRows(dataForShow, handleShowModalPets)}
          />
        )} */}

        <CustomTable
          columns={columns(handleShowModalPets) as ColumnsType<any>}
          rowKey={() => Math.random()}
          dataSource={dataForShow}
          bordered
          loading={isLoading}
          pagination={{
            pageSize: 5,
          }}
        />
      </ContainerTable>
    </Container>
  );
}
